module.exports = __webpack_public_path__ + "img/premiumhouse_logo1.1f74f72a.png";